import { graphql, Link, StaticQuery } from 'gatsby';
import marked from 'marked';
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

import { Location } from '../../interfaces/Location';
import { NodeAdvantage } from '../../interfaces/NodeAdvantage';
import { ThinTitle } from '../../styles/CommonStyledComponents';
import { getJsonByPathname } from '../../utils/GetJsonByPathname';
import { theme } from '../../utils/Theme';
import Headline from '../headline/Headline';

const StyledLink = styled(Link)`
  color: inherit;
`;

const AdvantagesWrapper = styled.div`
  width: 75%;
  margin: 0 auto;
  ${theme.mediaQuerySizes.bigScreen} {
    width: 80%;
  }
`;

const Advantage = styled.div`
  width: 50%;
  display: inline-grid;
  position: relative;
  padding: 0 30px 30px 50px;

  h1 {
    padding-left: 55px;
    padding-top: 25px;
  }
  p {
    padding-left: 55px;
  }

  ${theme.mediaQuerySizes.smallLaptop} {
    width: auto;
    text-align: center;
  }
  ${theme.mediaQuerySizes.smallScreen} {
    padding: 0;
    h1 {
      padding-left: 0px;
      padding-top: 0px;
    }
    p {
      padding-left: 0px;
    }
  }
`;

const AdvantageIcon = styled.img`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0px;
  ${theme.mediaQuerySizes.smallScreen} {
    display: none;
  }
`;

const query = graphql`
  query {
    allAdvantagesJson {
      nodes {
        advantages {
          title
          image
          description
          description
          link
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
  }
`;

interface AdvantageJsonNode {
  advantages: NodeAdvantage[];
  parent: {
    name: string;
  };
}

interface QueryResponse {
  allAdvantagesJson: {
    nodes: AdvantageJsonNode[];
  };
}

export const Advantages = (props: Location) => {
  return (
    <StaticQuery
      query={query}
      render={(data: QueryResponse) => (
        <>
          <Headline arrowColor="arrowViolet" title="Wyjątkowe miejsce dla Twojego dziecka"></Headline>
          <AdvantagesWrapper>
            {getJsonByPathname<AdvantageJsonNode, QueryResponse>(
              data,
              props.location.pathname,
              'allAdvantagesJson',
            )?.advantages?.map((element: NodeAdvantage, index: number) => (
              <Advantage key={index}>
                <AdvantageIcon src={element.image} />
                <StyledLink to={element.link}>
                  <ThinTitle>{element.title}</ThinTitle>
                </StyledLink>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(marked(element.description) || ''),
                  }}
                />
              </Advantage>
            ))}
          </AdvantagesWrapper>
        </>
      )}
    />
  );
};
